/**
 * GET_SURVEY_FAILURE
 */
function* getRapidScreenerFailure({ error }) {
  console.log('Success', error)
}

export default getRapidScreenerFailure